import DateFnsUtils from '@date-io/date-fns';
import { Button } from 'primereact/button';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React, { useCallback, useEffect } from 'react';
import {
  ClientTypeService,
  CurrencyService,
  GroupTypeService,
  ProductMarketService,
  ProductTypeService,
} from '../../../remote-api/api/master-services';
import { ProductService } from '../../../remote-api/api/product-services';
import { Paper } from '@material-ui/core';
import { el } from 'date-fns/locale';
import Asterisk from '../../../shared-components/components/red-asterisk';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    minHeight: 100,
    padding: 30,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 182,
    width: '90%',
  },
  header: {
    paddingTop: 10,
    paddingBottom: 10,
    color: 'primary',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
  },
  gridItem: {
    marginBottom: theme.spacing(2),
  },
}));

const producttypeservice = new ProductTypeService();
const currencyservice = new CurrencyService();
const prodmarketservice = new ProductMarketService();
const grouptypeservice = new GroupTypeService();
const clienttypeservice = new ClientTypeService();
const productservice = new ProductService();

let cs$ = currencyservice.getCurrencies();
let pt$ = producttypeservice.getProductTypes();
let gt$ = grouptypeservice.getGroupTypes();
let ct$ = clienttypeservice.getCleintTypes();
let pm$ = prodmarketservice.getProductMarket();

export default function ProductBasicDetailsComponent(props) {
  const classes = useStyles();

  const today = new Date();
  const tommorow = new Date();

  const [currencyList, setCurrencyList] = React.useState([]);
  const [productTypes, setProductTypes] = React.useState([]);
  const [productMarkets, setProductMarkets] = React.useState([]);
  const [clientTypes, setClientTypes] = React.useState([]);
  const [groupTypes, setGroupMarkets] = React.useState([]);

  const [state, setState] = React.useState({
    productBasicDetailsForm: {
      productTypeId: '',
      productTypeName: '',
      name: '',
      productMarketId: '',
      productMarketName: productMarkets?.find(p => p.code === 'PM243607')?.name,
      description: '',
      clientTypeId: '',
      groupTypeId: '',
      productCurrencyCd: '',
      validFrom: today,
      validUpTo: new Date(tommorow.setDate(today.getDate() + 365)),
      premiumCurrencyCd: '',
      isValid: false,
    },
  });

  const [showMessage, setShowMessage] = React.useState(false);

  useEffect(() => {
    if ('productBasicDetails' in props.productDetails) {
      setState({
        productBasicDetailsForm: {
          ...(() => {
            let res = props.productDetails.productBasicDetails;
            return res;
          })(),
        },
      });
    }

    // setFieldNamefromIds();
  }, [props?.productDetails]);

  const useObservable = (observable, setter) => {
    useEffect(() => {
      let subscription = observable.subscribe(result => {
        setter(result.content);
      });
      return () => subscription.unsubscribe();
    }, [observable, setter]);
  };

  useObservable(cs$, setCurrencyList);
  useObservable(pt$, setProductTypes);
  useObservable(pm$, setProductMarkets);
  useObservable(gt$, setGroupMarkets);
  useObservable(ct$, setClientTypes);

  const setFieldNamefromIds = () => {
    const prodDetails = props.productDetails?.productBasicDetails;
    if (!prodDetails?.productTypeName && prodDetails?.productTypeId) {
      const formObj = {
        ...prodDetails,
        productTypeName: productTypes.find(p => p.code === prodDetails?.productTypeId)?.name || '',
        productMarketName: productMarkets.find(p => p.code === prodDetails.productMarketId)?.name || '',
        clientTypeName: clientTypes.find(p => p.id === prodDetails.clientTypeId)?.name || '',
        groupTypeName: (prodDetails.groupTypeId && groupTypes.find(p => p.id === prodDetails.groupTypeId)?.name) || '',
      };

      setState({
        productBasicDetailsForm: formObj,
      });
      props.updateBasiDetails({
        productBasicDetailsForm: formObj,
      });
    }
  };

  const isFormValid = useCallback(() => {
    const form = state.productBasicDetailsForm;
    const requiredFields = [
      form.productTypeId,
      form.name,
      form.productMarketId,
      form.clientTypeId,
      form.productCurrencyCd,
      form.validFrom,
      form.validUpTo,
      form.premiumCurrencyCd,
    ];

    if (requiredFields.some(field => !field)) {
      return false;
    }

    // const clientTypeCode = clientTypes.find(ct => ct.id === form.clientTypeId)?.code;
    // if (clientTypeCode === 'GROUP' && !form.groupTypeId) {
    //   return false;
    // }

    if (form.validFrom > form.validUpTo) {
      return false;
    }

    return true;
  }, [state.productBasicDetailsForm, clientTypes]);
  // const handleChange = event => {
  //   const { name, value } = event.target;
  //   const formObj = {
  //     ...state.productBasicDetailsForm,
  //     [name]: value,
  //     ...(name === 'productTypeId' && value && { productTypeName: productTypes.find(p => p.code === value).name }),
  //     ...(name === 'productMarketId' && value && { productMarketName: productMarkets.find(p => p.code === value).name }),
  //     ...(name === 'clientTypeId' && value && { clientTypeName: clientTypes.find(p => p.id === value).name }),
  //     ...(name === 'groupTypeId' && value && { groupTypeName: groupTypes.find(p => p.id === value).name }),
  //   };

  //   setState({
  //     productBasicDetailsForm: formObj,
  //   });

  //   props.updateBasiDetails({
  //     productBasicDetailsForm: formObj,
  //   });

  // };

  const handleChange = event => {
    const { name, value } = event.target;

    // Create the updated form object
    const formObj = {
      ...state.productBasicDetailsForm,
      [name]: value,
      ...(name === 'productTypeId' &&
        value && {
          productTypeName: productTypes.find(p => p.code === value)?.name || '',
        }),
      ...(name === 'productMarketId' &&
        value && {
          productMarketName: productMarkets.find(p => p.code === value)?.name || '',
        }),
      ...(name === 'clientTypeId' &&
        value && {
          clientTypeName: clientTypes.find(p => p.id === value)?.name || '',
        }),
      ...(name === 'groupTypeId' &&
        value && {
          groupTypeName: groupTypes.find(p => p.id === value)?.name || '',
        }),
    };

    // Update local state
    setState({
      productBasicDetailsForm: formObj,
    });

    // Update parent component
    props.updateBasiDetails({
      productBasicDetailsForm: formObj,
    });

    // Immediately trigger validation after update
    if (props.registerValidationFn) {
      props.registerValidationFn(() => isFormValid());
    }
  };
  const handleValidFromChange = date => {
    const formObj = {
      ...state.productBasicDetailsForm,
      validFrom: date,
    };
    setState({
      productBasicDetailsForm: formObj,
    });
    props.updateBasiDetails({
      productBasicDetailsForm: formObj,
    });
  };

  const handleValidToChange = date => {
    const formObj = {
      ...state.productBasicDetailsForm,
      validUpTo: date,
    };
    setState({
      productBasicDetailsForm: formObj,
    });
    props.updateBasiDetails({
      productBasicDetailsForm: formObj,
    });
  };

  //   const isFormValid = () => {
  //   const form = state.productBasicDetailsForm;
  //   if (!form.productTypeId || !form.name || !form.productMarketId || !form.clientTypeId || !form.productCurrencyCd || !form.validFrom || !form.validUpTo || !form.premiumCurrencyCd) {
  //     return false;
  //   }
  //   if (form.clientTypeId === 'GROUP' && !form.groupTypeId) {
  //     return false;
  //   }

  //   // Validity dates check
  //   if (form.validFrom > form.validUpTo) {
  //     return false;
  //   }

  //   return true;
  // };

  // const isFormValid = () => {
  //   const form = state.productBasicDetailsForm;
  //   if (
  //     !form.productTypeId ||
  //     !form.name ||
  //     !form.productMarketId ||
  //     !form.clientTypeId ||
  //     !form.productCurrencyCd ||
  //     !form.validFrom ||
  //     !form.validUpTo ||
  //     !form.premiumCurrencyCd
  //   ) {
  //     return false;
  //   }
  //   if (form.clientTypeId === 'GROUP' && !form.groupTypeId) {
  //     return false;
  //   }
  //   if (form.validFrom > form.validUpTo) {
  //     return false;
  //   }
  //   return true;
  // };

  // const isFormValid = useCallback(() => {
  //   const form = state.productBasicDetailsForm;
  //   if (
  //     !form.productTypeId ||
  //     !form.name ||
  //     !form.productMarketId ||
  //     !form.clientTypeId ||
  //     !form.productCurrencyCd ||
  //     !form.validFrom ||
  //     !form.validUpTo ||
  //     !form.premiumCurrencyCd
  //   ) {
  //     return false;
  //   }

  //   const clientTypeCode = clientTypes.find(ct => ct.id === form.clientTypeId)?.code;
  //   if (clientTypeCode === 'GROUP' && !form.groupTypeId) {
  //     return false;
  //   }

  //   if (form.validFrom > form.validUpTo) {
  //     return false;
  //   }

  //   return true;
  // }, [state.productBasicDetailsForm, clientTypes]);

  useEffect(() => {
    if (props.registerValidationFn) {
      props.registerValidationFn(isFormValid);
    }

    if (props.registerValidationFn) {
      props.registerValidationFn(() => isFormValid());
    }
  }, [props.registerValidationFn, isFormValid]);

  useEffect(() => {
    if (props.registerValidationFn) {
      props.registerValidationFn(isFormValid);
    }
  }, [props.registerValidationFn, isFormValid]);

  const handleSubmit = e => {
    // if (state.productBasicDetailsForm.validFrom > state.productBasicDetailsForm.validUpTo) {
    //   setShowMessage(true);
    //   return;
    // }
    if (!isFormValid()) {
      setShowMessage(true);
      return;
    }
    let payload = {
      productBasicDetails: {
        ...state.productBasicDetailsForm,
        validFrom: new Date(state.productBasicDetailsForm.validFrom).getTime(),
        validUpTo: new Date(state.productBasicDetailsForm.validUpTo).getTime(),
      },
    };

    const productId = localStorage.getItem('productId');
    if (productId) {
      productservice.editProduct(payload.productBasicDetails, productId, 1).subscribe(res => {
        if (res.status === 200) {
          props.handleNextStep();
        }
      });
    } else {
      productservice.saveProductBasicDetails(payload.productBasicDetails).subscribe(res => {
        if (res.status === 201) {
          localStorage.setItem('productId', res.data.id);
          props.handleNextStep();
        }
      });
    }
  };

  const handleSnackClose = (event, reason) => {
    setShowMessage(false);
  };

  return (
    <Paper elevation="none" style={{ padding: '16px' }}>
      <Grid container alignItems="center">
        <Snackbar open={showMessage} autoHideDuration={6000} onClose={handleSnackClose}>
          <Alert onClose={handleSnackClose} variant="filled" severity="error">
            Valid upto should be greater than valid from
          </Alert>
        </Snackbar>

        <Grid item container>
          <Grid item xs={12}>
            <Grid item xs={12} sm={6} md={4} className={classes.header} color="inherit">
              <span>Product Basic Details</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item container alignItems="center" className={classes.gridItem}>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }} color="inherit">
                Product Type <Asterisk />
              </InputLabel>

              <Select
                name="productTypeId"
                color="inherit"
                value={(() => {
                  const id = state?.productBasicDetailsForm?.productTypeId;
                  if (id) sessionStorage.setItem('productTypeName', productTypes?.find(ele => id === ele.code)?.name);
                  return id;
                })()} // Use `value` to bind the selected value
                onChange={handleChange} // Handle value change
                className={classes.selectEmpty}
                inputProps={{ 'aria-label': 'Without label' }}>
                {productTypes?.map(ele => {
                  return (
                    <MenuItem key={ele.code} value={ele.code}>
                      {ele.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl className={classes.formControl}>
              <TextField
                id="product-name"
                name="name"
                value={state.productBasicDetailsForm.name}
                onChange={handleChange}
                // label="Name "
                label={
                  <>
                    Name <Asterisk />
                  </>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                Product Market <Asterisk />
              </InputLabel>
              <Select
                name="productMarketId"
                color="inherit"
                value={(() => {
                  const id = state?.productBasicDetailsForm?.productMarketId;
                  if (id) sessionStorage.setItem('productMarketName', productMarkets?.find(ele => ele.code === id)?.name);
                  return id;
                })()}
                onChange={handleChange}
                // displayEmpty
                className={classes.selectEmpty}
                inputProps={{ 'aria-label': 'Without label' }}>
                {productMarkets.map(ele => {
                  return (
                    <MenuItem key={ele.code} value={ele.code}>
                      {ele.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FormControl className={classes.formControl}>
              <TextField
                id="product-desc"
                label="Description"
                name="description"
                multiline
                maxRows={10}
                Rows={1}
                value={state.productBasicDetailsForm.description}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid item container alignItems="center" className={classes.gridItem}>
          {/* <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="product-desc"
                label="Description"
                name="description"
                multiline
                maxRows={10}
                rows={1}
                value={state.productBasicDetailsForm.description}
                onChange={handleChange}
              />
            </FormControl>
          </Grid> */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl className={classes.formControl} style={{ alignSelf: 'flex-end' }}>
              <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                Client Type <Asterisk />
              </InputLabel>
              <Select
                name="clientTypeId"
                value={(() => {
                  const id = state?.productBasicDetailsForm?.clientTypeId;

                  if (id) sessionStorage.setItem('clientTypeName', clientTypes?.find(ele => ele.code === id)?.name);
                  return id;
                })()}
                onChange={handleChange}
                displayEmpty
                className={classes.selectEmpty}
                inputProps={{ 'aria-label': 'Without label' }}>
                {clientTypes.map(ele => {
                  return <MenuItem value={ele.id}>{ele.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            {state.productBasicDetailsForm.clientTypeId === 'GROUP' ? (
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                  Group Type <Asterisk />
                </InputLabel>
                <Select
                  name="groupTypeId"
                  value={(() => {
                    const id = state?.productBasicDetailsForm?.groupTypeId;
                    if (id)
                      sessionStorage.setItem('groupTypeName', id ? groupTypes?.find(ele => ele.code === id)?.name : '');
                    return id;
                  })()}
                  onChange={handleChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  inputProps={{ 'aria-label': 'Without label' }}>
                  {groupTypes?.map(ele => {
                    return <MenuItem value={ele.id}>{ele.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            ) : (
              `Client Type: ${state?.productBasicDetailsForm?.clientTypeId}`
            )}
          </Grid>
        </Grid>

        <Grid item container alignItems="center" className={classes.gridItem}>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                Product Currency <Asterisk />
              </InputLabel>
              <Select
                name="productCurrencyCd"
                value={state?.productBasicDetailsForm?.productCurrencyCd}
                onChange={handleChange}
                displayEmpty
                className={classes.selectEmpty}
                inputProps={{ 'aria-label': 'Without label' }}>
                {currencyList.map(ele => {
                  return <MenuItem value={ele.code}>{ele.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl className={classes.formControl}>
                <KeyboardDatePicker
                  views={['year', 'month', 'date']}
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="valid-from"
                  autoOk={true}
                  label={
                    <>
                      Valid From <Asterisk />
                    </>
                  }
                  name="validFrom"
                  value={state?.productBasicDetailsForm?.validFrom}
                  onChange={handleValidFromChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl className={classes.formControl}>
                <KeyboardDatePicker
                  views={['year', 'month', 'date']}
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="valid-upto"
                  autoOk={true}
                  label={
                    <>
                      Valid Upto <Asterisk />
                    </>
                  }
                  name="validUpTo"
                  value={state?.productBasicDetailsForm?.validUpTo}
                  onChange={handleValidToChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl className={classes.formControl} style={{ marginTop: '16px' }}>
                <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                  Premium Currency <Asterisk />
                </InputLabel>
                <Select
                  name="premiumCurrencyCd"
                  value={state?.productBasicDetailsForm?.premiumCurrencyCd}
                  onChange={handleChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  inputProps={{ 'aria-label': 'Without label' }}>
                  {currencyList.map(ele => {
                    return <MenuItem value={ele.code}>{ele.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>

        <Grid item container alignItems="center" className={classes.gridItem}>
          {/* <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl} style={{ marginTop: '16px' }}>
              <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                Premium Currency
              </InputLabel>
              <Select
                name="premiumCurrencyCd"
                value={state.productBasicDetailsForm.premiumCurrencyCd}
                onChange={handleChange}
                displayEmpty
                className={classes.selectEmpty}
                inputProps={{ 'aria-label': 'Without label' }}>
                {currencyList.map(ele => {
                  return <MenuItem value={ele.code}>{ele.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid> */}
        </Grid>

        <Grid item container alignItems="center" className={classes.gridItem}>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
            {!localStorage.getItem('productId') && (
              <Button variant="contained" onClick={handleSubmit} disabled={!isFormValid()}>
                Save and Next
              </Button>
            )}
            {/* <Button variant="contained" onClick={handleClose} className="p-button-text">
                    Cancel
                  </Button> */}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
